import type { IReduxState } from 'types';

export const getGeneral = (state: IReduxState) => state.general;
export const getUserData = (state: IReduxState) => getGeneral(state).user;
export const getUserTiers = (state: IReduxState) => getUserData(state).tiers;
export const getIsDarkModeEnabled = (state: IReduxState) => getGeneral(state).isDarkModeEnabled;
export const getIsOSThemeEnabled = (state: IReduxState) => getGeneral(state).useOsTheme;
